export const baseAPIUrl =
process.env['FIREBASE_APP_SERVER_ENDPOINT'] ||
'http://localhost:5001/expertify-tasks-dev/us-central1/api'
/* export const baseAPIUrl =  'https://74a1-196-179-32-170.ngrok.io/expertify-tasks-dev/us-central1/api' */
//process.env['FIREBASE_APP_SERVER_ENDPOINT'] || 'http://localhost:5001/expertify-tasks-dev/us-central1/api'
/*this should be updated ngrok */ export const APP_API_KEY =
  process.env['SHOPIFY_APP_API_KEY'] ||
  '7664216238e0aad2692df7c2f710ae71' /*this should be your app API key*/
